import { composeIO } from 'react-compose-io'
import { graficoLinhasIO } from './GraficoLinhas.IO'
import { GraficoLinhasView } from './GraficoLinhas.View'

export const GraficoLinhas = composeIO(GraficoLinhasView, graficoLinhasIO)
